class CollectionConfigurationService {

  static async retrieveCollectionRules(collectionId) {
    const COLLECTION_RULES = window.APP_CONFIG.collections;

    for (var key of Object.keys(COLLECTION_RULES)) {
      COLLECTION_RULES[key].minDate = new Date(COLLECTION_RULES[key].minDate);
      COLLECTION_RULES[key].maxDate = new Date(COLLECTION_RULES[key].maxDate);
    }

    return new Promise((resolve, reject) => {
      if (COLLECTION_RULES[collectionId]) {
        return resolve(COLLECTION_RULES[collectionId]);
      }
      reject("Collection not found");
    });
  }

}

export default CollectionConfigurationService;